import React, { useState } from "react";
import MyNavbar from "../../components/customer/navbar/MyNavbar"; // ✅
import MySidebar from "../../components/customer/sidebar/MySidebar";
// import { Outlet } from "react-router-dom";
import MyFooter from "../../components/customer/footer/MyFooter";
import "../../assets/styles/customer/layout/MyLayout.css"

/* const MyLayout = ({ children }) => {
 */
const MyLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    
    <div className="main-layout">
      {/* Navbar */}
      <MyNavbar onMenuClick={toggleSidebar} />

      {/* Sidebar - Mobile Only */}
      <MySidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      {/* Main Content */}
      <main className="main-content">
        <div className="container-fluid">
          {/*           {children}
           */}
          {/* <Outlet /> */}
          {children}
        </div>
      </main>
      <MyFooter/>
    </div>
  );
};

export default MyLayout;

/* import React, { useState } from "react";
import MyNavbar from "../navbar/MyNavbar";
import MySidebar from "../sidebar/MySidebar";
import { Outlet } from "react-router-dom";
import "./MyLayout.css";

const MyLayout = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => setShowSidebar(!showSidebar);

  return (
    <div className="app-layout">
      <MyNavbar toggleSidebar={toggleSidebar} />
      <MySidebar show={showSidebar} onHide={toggleSidebar} />
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
};

export default MyLayout; */

/* import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import MySidebar from "../sidebar/MySidebar";
import MyNavbar from "../navbar/MyNavbar";
import "./MyLayout.css";

const MyLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((s) => !s);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="app-root d-flex">
      <MySidebar show={sidebarOpen} onHide={closeSidebar} />
      <div className="content flex-grow-1">
        <MyNavbar onToggleSidebar={toggleSidebar} />
        <main className="p-3">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
export default MyLayout;
 */
